// extracted by mini-css-extract-plugin
module.exports = {"codeEditor":"CodeEditor_codeEditor__1v7lO","codeEditorSubheader":"CodeEditor_codeEditorSubheader__3mO7h","codeEditorArea":"CodeEditor_codeEditorArea__1Gozk"};